import { RimItemTC, RimSectionTC, VatPercentageTC, VatThresholdTC } from '../../../business/models/typecode.enums';

import { OverallTotal } from './types';
import { RimLine } from '../rim/types';

export function mapDaccaOverallTotalToRimLines(diy: OverallTotal[], fin: OverallTotal[], diyDescription: string, finDescription: string, isCocoon: boolean): RimLine[] {
  const mappedLines: RimLine[] = [];

  const diyWork = diy.filter(p => p.vatPercentage === 0)[0] && diy.filter(p => p.vatPercentage === 0)[0].total.totalLabour;
  const diyMaterialVat0 = diy.filter(p => p.vatPercentage === 0)[0] && diy.filter(p => p.vatPercentage === 0)[0].total.totalMaterial;
  const diyMaterialVat21 = diy.filter(p => p.vatPercentage === 21)[0] && diy.filter(p => p.vatPercentage === 21)[0].total.totalMaterial;
  const finTotalVat6 = fin.filter(p => p.vatPercentage === 6)[0] && fin.filter(p => p.vatPercentage === 6)[0].total.total;
  const finTotalVat21 = fin.filter(p => p.vatPercentage === 21)[0] && fin.filter(p => p.vatPercentage === 21)[0].total.total;
  const finMaterialVat0 = fin.filter(p => p.vatPercentage === 0)[0] && fin.filter(p => p.vatPercentage === 0)[0].total.totalMaterial;

  if (diyWork) {
    mappedLines.push( {
      id: 0, sequence: 1, amount: diyWork.toString(), description: diyDescription, vatPercentageTC: '', vatThresholdTC: VatThresholdTC.For, amount80: isCocoon ? diyWork.toString() : '',
      invoicePresent: false, rimSectionTC: RimSectionTC.Bu1, rimItemTC: RimItemTC.Werkuren, deleted: false, vatEnabled: false,
      vatPercentageEnabled: false, amountEnabled: false, invoicePresentEnabled: false, rimItemValuesBySection: [], isImportFromDacca: true
    } as RimLine);
  }
  if (diyMaterialVat0) {
    mappedLines.push( {
      id: 0, sequence: 1, amount: diyMaterialVat0.toString(), description: diyDescription, vatPercentageTC: '', vatThresholdTC: VatThresholdTC.For, amount80: isCocoon ? diyMaterialVat0.toString() : '',
      invoicePresent: false, rimSectionTC: RimSectionTC.Co1, rimItemTC: RimItemTC.Materiaal, deleted: false, vatEnabled: false,
      vatPercentageEnabled: false, amountEnabled: false, invoicePresentEnabled: false, rimItemValuesBySection: [], isImportFromDacca: true
    } as RimLine);
  }
  if (diyMaterialVat21) {
    mappedLines.push( {
      id: 0, sequence: 1, amount: diyMaterialVat21.toString(), description: diyDescription, vatPercentageTC: VatPercentageTC.Vat21, vatThresholdTC: VatThresholdTC.Exc, amount80: isCocoon ? (diyMaterialVat21 * 0.8).toString() : '',
      invoicePresent: true, rimSectionTC: RimSectionTC.Bu1, rimItemTC: RimItemTC.Materiaal, deleted: false, vatEnabled: false,
      vatPercentageEnabled: false, amountEnabled: false, invoicePresentEnabled: false, rimItemValuesBySection: [], isImportFromDacca: true
    } as RimLine);
  }
  if (finTotalVat6) {
    mappedLines.push( {
      id: 0, sequence: 1, amount: finTotalVat6.toString(), description: finDescription, vatPercentageTC: VatPercentageTC.Vat6, vatThresholdTC: VatThresholdTC.Exc, amount80: isCocoon ? (finTotalVat6 * 0.8).toString() : '',
      invoicePresent: true, rimSectionTC: RimSectionTC.Bu1, rimItemTC: RimItemTC.Hoofdsom, deleted: false, vatEnabled: false,
      vatPercentageEnabled: false, amountEnabled: false, invoicePresentEnabled: false, rimItemValuesBySection: [], isImportFromDacca: true
    } as RimLine);
  }
  if (finTotalVat21) {
    mappedLines.push( {
      id: 0, sequence: 1, amount: finTotalVat21.toString(), description: finDescription, vatPercentageTC: VatPercentageTC.Vat21, vatThresholdTC: VatThresholdTC.Exc, amount80: isCocoon ? (finTotalVat21 * 0.8).toString() : '',
      invoicePresent: true, rimSectionTC: RimSectionTC.Bu1, rimItemTC: RimItemTC.Hoofdsom, deleted: false, vatEnabled: false,
      vatPercentageEnabled: false, amountEnabled: false, invoicePresentEnabled: false, rimItemValuesBySection: [], isImportFromDacca: true
    } as RimLine);
  }
  if (finMaterialVat0) {
    mappedLines.push( {
      id: 0, sequence: 1, amount: finMaterialVat0.toString(), description: finDescription, vatPercentageTC: '', vatThresholdTC: VatThresholdTC.For, amount80: isCocoon ? finMaterialVat0.toString() : '',
      invoicePresent: false, rimSectionTC: RimSectionTC.Co1, rimItemTC: RimItemTC.Materiaal, deleted: false, vatEnabled: false,
      vatPercentageEnabled: false, amountEnabled: false, invoicePresentEnabled: false, rimItemValuesBySection: [], isImportFromDacca: true
    } as RimLine);
  }

  const sortedLines = mappedLines.sort((a, b) => {
    return a.rimSectionTC.toUpperCase() > b.rimSectionTC.toUpperCase()
    ? 1
    : a.rimSectionTC.toUpperCase() < b.rimSectionTC.toUpperCase()
      ? -1
      : +a.vatPercentageTC > +b.vatPercentageTC
        ? 1
        : +a.vatPercentageTC < +b.vatPercentageTC
          ? -1
          : a.rimItemTC.toUpperCase() > b.rimItemTC.toUpperCase()
            ? 1
            : a.rimItemTC.toUpperCase() < b.rimItemTC.toUpperCase()
              ? -1
              : 0;
  });

  let lastRimSectionTC = '';

  const sortedSequenceLines = sortedLines.map((line, index) => {
    const rimSectionTC = index > 0 ? getNextRimSectionTC(line, sortedLines[index - 1], lastRimSectionTC) : line.rimSectionTC;
    lastRimSectionTC = rimSectionTC;
    return {...line, sequence: index + 1, rimSectionTC: rimSectionTC };
  });

  return sortedSequenceLines;
}

function getNextRimSectionTC(currentLine: RimLine, previousLine: RimLine, lastRimSectionTC: string ): string {
  let result = currentLine.rimSectionTC;
  if (result === RimSectionTC.Bu1) {
    result = currentLine.vatPercentageTC === previousLine.vatPercentageTC && currentLine.rimItemTC !== previousLine.rimItemTC
            ? lastRimSectionTC
            : lastRimSectionTC === RimSectionTC.Bu1
              ? RimSectionTC.Bu2
              : RimSectionTC.Bu3;
  } else if (result === RimSectionTC.Co1) {
      result = currentLine.rimSectionTC !== previousLine.rimSectionTC
                      ? RimSectionTC.Co1
                      : RimSectionTC.Co2;
  }
  return result;
}
